import { errorHandler } from '@/utils/helpers/error-handler.js';
import Vue from 'vue';
export const endpointUrl = '/api/services/emails';

export default {
  async sendEmail(payload = {}, params = {}) {
    console.log('sendEmail - Sending email with payload:', payload);
    console.log('sendEmail - Sending email with params:', params);
    const response = await Vue.prototype.$harbourData
      .post(`${endpointUrl}/send`, payload, params)
      .catch((err) => {
        errorHandler('sendEmail', err);
      });
      const data = response?.data;
      if (!data) {
        throw new Error('No data returned from sendEmail response');
      }
      return data;
  }
};
